import React from 'react';
import { Spin } from 'antd';
import { I18n } from '@aws-amplify/core';

import { PatchMessage, PatchPanel, PatchTitle } from './styles';

const PROCESSING_TITLE = 'One or more stretches were replaced. The video is being updated with the new stretches.';
const PROCESSING_MESSAGE = 'While the video is not available, it is possible to review the B.E.R.A. evaluation.';

export function PatchProcessing(): JSX.Element {
	return (
		<PatchPanel>
			<Spin size="large" />
			<PatchTitle>{I18n.get(PROCESSING_TITLE)}</PatchTitle>
			<PatchMessage>{I18n.get(PROCESSING_MESSAGE)}</PatchMessage>
		</PatchPanel>
	);
}
